<template>
  <div class="wrapper">
    <div class="wrapper-content row">
      <h1>
        ТЕКСТ
      </h1>
      <div class="container row buttons line-bottom">
        <big-title> 24px BOLD </big-title>
        <medium-title> 16px </medium-title>
        <main-title> 14px </main-title>
      </div>
    </div>

    <div class="wrapper-container">
      <div class="wrapper-content">
        <h1>
          SHARED
        </h1>

        <div class="wrapper-content row wrap">
          <label-custom label-text="test"/>
          <div class="container buttons line-bottom">
            <h2>
              ИНПУТЫ
            </h2>
            <div class="content">
              <input-main :info-input="defaultInput"/>
              <input-main :rules="rulesRequired"
                          :info-input="defaultInput"/>
              <input-main :info-input="{...defaultInput, typeInput: 'search'}"/>
              <input-main :info-input="defaultInput" :active-textarea="true"/>
              <input-main :rules="rulesRequired"
                          :active-textarea="true"
                          :info-input="defaultInput"/>

              <file-input :file="defaultFileInput"
                          @removeFile="file => defaultFileInput.file = null"
                          @changeFile="(value, file) => defaultFileInput.file = file"/>

              <picker-menu-date value=""/>
              <toggle name-check="wrapper-content"/>
              <checkbox value="Value Value"/>
              <button-show :is-active="true"/>
              <button-show :is-active="false"/>
            </div>
          </div>
          <div class="container buttons line-bottom">
            <h2>
              КНОПКИ
            </h2>
            <div class="content">
              <button-main> btn text </button-main>
              <button-main :active="true"> btn active text </button-main>
              <button-main :disabled="true"> btn text disabled </button-main>
              <button-square> 1 </button-square>
              <button-square :active="true"> 2 </button-square>
              <button-square :active="true"
                             :is-active-icon="true">
                <IconText/>
              </button-square>
              <button-square :is-active-icon="true">
                <IconText/>
              </button-square>
            </div>
          </div>
        </div>
      </div>
      <template-pagination :active-page="activePage"
                           @changePage="page => activePage = page"
                           :page-total="10">
        <row-item title="name"
                  :active-c-r-u-d="rowItemActions" :id="0"/>
        <row-item title="name"
                  :dom-title="'view'" :active-c-r-u-d="rowItemActionsView" :id="1"/>
        <row-item title="name with sub title"
                  :dom-title="'with-sub-title'"
                  :active-c-r-u-d="rowItemActionsBtn"
                  :id="2">
          <template v-slot:subTitle>
            werwerwer
          </template>
          <template v-slot:rowItem>
            <button-square :active="true"
                           :is-active-icon="true">
              <IconText/>
            </button-square>
          </template>
        </row-item>
        <row-item title="name download"
                  :dom-title="'download'"
                  :active-c-r-u-d="rowItemActionDownload" :id="3"/>
      </template-pagination>
    </div>
  </div>
</template>

<script>
import MediumTitle from "@/components/shared/text/MediumTitle.vue";
import BigTitle from "@/components/shared/text/BigTitle.vue";
import MainTitle from "@/components/shared/text/MainTitle.vue";
import ButtonMain from "@/components/shared/buttons/ButtonMain.vue";
import InputMain from "@/components/shared/input/InputMain.vue";
import rulesMixin from "@/mixins/rules.mixin";
import FileInput from "@/components/shared/input/FileInput.vue";
import ButtonSquare from "@/components/shared/buttons/ButtonSquare.vue";

import IconText from "@/assets/icons/ui/search.svg?inline"
import TemplatePagination from "@/components/entities/pagination/TemplatePagination.vue";
import PickerMenuDate from "@/components/shared/picker/PickerMenuDate.vue";
import Toggle from "@/components/shared/toggle/Toggle.vue";
import Checkbox from "@/components/shared/checkbox/Checkbox.vue";
import ButtonShow from "@/components/shared/buttons/ButtonShow.vue";
import RowItem from "@/components/entities/items/RowItem.vue";
import LabelCustom from "@/components/shared/LabelCustom.vue";

export default {
  name: "TestPage",
  components: {
    LabelCustom,
    RowItem,
    ButtonShow,
    Checkbox,
    Toggle,
    PickerMenuDate,
    TemplatePagination,
    ButtonSquare, FileInput, InputMain, ButtonMain, MainTitle, BigTitle, MediumTitle, IconText},
  mixins: [rulesMixin],
  data() {
    return {
      rowItemActions: [
        {
          active: false,
          type: 'view',
          action: () => console.log('view')
        },
        {
          type: 'edit',
        },
        {
          type: 'remove',
          action: () => console.log('remove')
        },
      ],
      rowItemActionsView: [
        {
          active: true,
          type: 'view',
          action: () => console.log('view')
        },
        {
          type: 'edit',
          action: () => console.log('edit')
        },
        {
          type: 'remove',
          action: () => console.log('remove')
        },
      ],

      rowItemActionDownload: [
        {
          type: 'download',
          action: () => console.log('download')
        },
        {
          type: 'edit',
          action: () => console.log('edit')
        },
        {
          type: 'remove',
          action: () => console.log('remove')
        },
      ],

      rowItemActionsBtn: [
        {
          btnText: 'btn text',
          type: 'btn',
          action: () => console.log('btn')
        },
        {
          type: 'edit'
        },
        {
          type: 'remove',
          action: () => console.log('remove')
        },
      ],
      activePage: 1,
      defaultFileInput:
          {
            placeholder: "Загрузить превью новости",
            isChange: false,
            placeholderActive: "Заменить файл",
            btnText: 'Паспорт',
            mimetype: 'image/png, image/jpeg, image/jpg',
            mimeTypeString: '.png, .jpeg, .jpg',
            size: 0.003,
            filesLength: 5,
            title: 'Загрузите не более 5 файлов до 10 ГБ',
            type: 'PASSPORT',
            file: null
          },
      defaultInput: {
        title: 'default',
        placeholder: 'test',
        value: '',
        change: false,
        key: 'test',
        maxLength: 1
      },
    }
  }
}
</script>

<style scoped lang="scss">

.line-bottom {
  padding-bottom: 16px;
}
.wrapper {
  max-width: 1600px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  column-gap: 16px;
  row-gap: 16px;
  padding: 16px;

  .wrapper-container {
    display: flex;
    flex-direction: row;
    row-gap: 8px;
    column-gap: 8px;
    width: 100%;
  }

  .wrapper-content {
    display: flex;
    flex-direction: column;
    row-gap: 8px;
    align-items: center;
    width: 100%;


    &.row {
      max-width: 100%;
      align-items: flex-start;
      flex-direction: row;
    }

    &.buttons {
      max-width: 500px;
      width: 100%;
    }
  }


  .container {
    display: flex;
    flex-direction: column;
    row-gap: 16px;
    align-items: center;
    &.row {
      justify-content: center;
      flex-direction: row;
      column-gap: 32px;
    }
    &.card {
      max-width: 500px;
    }
    &.buttons {
      max-width: 500px;
      width: 100%;
    }

    .content {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      row-gap: 8px;

      & > * {
        width: 100%;
      }
    }
  }
}
</style>